import { render, staticRenderFns } from "./SettingWalletWithdraw.vue?vue&type=template&id=38fff7c2&"
import script from "./SettingWalletWithdraw.vue?vue&type=script&lang=js&"
export * from "./SettingWalletWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./SettingWalletWithdraw.vue?vue&type=style&index=0&id=38fff7c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports